import React from 'react';
import { Box, Chip } from '@mui/material';
import { ColumnImportData } from '../parse';
import { InventoryField } from 'common/modules/inventory';

interface Props {
	importData: ColumnImportData['toUpdate'];
	existingColumns: InventoryField[];
}

const UpdatedColumns = (props: Props) => {
	return (
		<Box mt={2} ml={2.5}>
			{Object.entries(props.importData).map(([key, value]) => {
				const previousValue = props.existingColumns.find((c) => c.id === key)?.label;
				const label = previousValue ? `${previousValue} -> ${value}` : value;
				return <Chip key={key} sx={{ m: 0.5 }} label={label} variant="outlined" />;
			})}
		</Box>
	);
};

export default UpdatedColumns;
